/* ============================================================
   AMARIN — Microinteracciones y scroll reveal
   Mejora progresiva: si algo falla, el contenido NUNCA queda oculto.
   ============================================================ */
(function () {
  "use strict";

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var supported = "IntersectionObserver" in window;

  // Sin soporte o con motion reducido: no ocultamos nada.
  if (!supported || reduce) return;

  function init() {
    var root = document.documentElement;
    root.classList.add("am-motion");

    // Elementos a revelar (con stagger dentro de cada sección).
    var targets = [];
    document.querySelectorAll(".dt-sc-section-wrapper").forEach(function (section) {
      var items = section.querySelectorAll(
        ".product-grid-item, .grid-item, .dt-sc-collection-section, .dt-sc-heading, .dt-sc-testimonial-content-inner"
      );
      if (items.length) {
        items.forEach(function (el, i) {
          el.classList.add("am-reveal");
          el.style.transitionDelay = Math.min(i * 70, 420) + "ms";
          targets.push(el);
        });
      } else {
        section.classList.add("am-reveal");
        targets.push(section);
      }
    });

    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("am-in");
            var sec = entry.target.closest(".dt-sc-section-wrapper");
            if (sec) sec.classList.add("am-in");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -8% 0px" }
    );

    targets.forEach(function (el) { io.observe(el); });

    // Salvavidas: pase lo que pase, a los 2.5s todo queda visible.
    setTimeout(function () {
      targets.forEach(function (el) { el.classList.add("am-in"); });
    }, 2500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
